export default "__VITE_ASSET__df7b50c4__"